import React from 'react';
import { BrowserRouter, Switch, Route } from "react-router-dom";

import HomePage from './components/website/HomePage';
import TeamPage from './components/website/TeamPage';
import SolutionsPage from './components/website/SolutionsPage';
import ScheduleLibrary from './components/website/SchedulingLibrary';
import ContactPage from './components/website/ContactPage';
import DemoManagementPage from './components/website/DemoManagementPage';
import PrivacyPolicyPage from './components/website/PrivacyPolicyPage';
import TermsAndConditionsPage from './components/website/TermsAndConditionsPage';

import SchedulingApp from './components/SchedulingApp';
import { SharedStateProvider } from './components/shared/SharedStateContext';

export default function App() {
	return (
		<SharedStateProvider>
			<div className="App">
				<BrowserRouter>
						<Switch>
							<Route exact path='/' render={() => ( <HomePage/>)}/>
							<Route exact path='/solutions/:school_type?' render={(props) => ( <SolutionsPage {...props}/>)}/>
							<Route exact path='/library' render={() => ( <ScheduleLibrary/>)}/>
							<Route exact path='/team' render={() => ( <TeamPage/>)}/>
							<Route exact path='/contact' render={() => ( <ContactPage/>)}/>
							<Route exact path='/demo/manage' render={() => ( <DemoManagementPage/>)}/>
							<Route exact path='/privacy' render={() => ( <PrivacyPolicyPage/>)}/>
							<Route exact path='/terms' render={() => ( <TermsAndConditionsPage/>)}/>
							<Route path='/app/:school_type?/:screen?' render={(props) => (<SchedulingApp {...props}/>)} />
						</Switch>
				</BrowserRouter>
			</div>
		</SharedStateProvider>
	)
}
